import {groq} from 'next-sanity';

import {imageWebFromImageWebSchema} from '@/modules/foundation/sanity/image/query';
import {internalLinkToHref} from '@/modules/foundation/sanity/link/query';

import type {ProductInCard} from '../shared/types';

import {DOCUMENT_TYPE_PRODUCT} from './constants';
import type {ProductSchema} from './schema';

export const PRODUCT_IN_CARD_FRAGMENT = groq`
	_id,
	title,
	slug,
	mainImage,
	orderRank,
	productType->{
		_id,
		title,
		orderRank,
		category->{
			_id,
			title,
			orderRank
		}
	}
`;

export type ProductInCardFragment = Pick<ProductSchema, '_id' | 'title' | 'slug' | 'mainImage'> & {
	orderRank?: string;
	productType?: {
		_id: string;
		title?: string;
		orderRank?: string;
		category?: {
			_id: string;
			title?: string;
			orderRank?: string;
		};
	};
};

export function productInCardFragmentToProductInCard(
	product: ProductInCardFragment,
): ProductInCard {
	return {
		title: product.title ?? '',
		href: internalLinkToHref(DOCUMENT_TYPE_PRODUCT, product.slug?.current),
		imageWeb: product?.mainImage?.asset?._ref
			? imageWebFromImageWebSchema(product.mainImage)
			: undefined,
		orderRank: product.orderRank,
		productType: {
			title: product.productType?.title ?? '',
			_id: product.productType?._id ?? '',
			orderRank: product.productType?.orderRank,
		},
		category: {
			_id: product.productType?.category?._id ?? '',
			title: product.productType?.category?.title ?? '',
			orderRank: product.productType?.category?.orderRank,
		},
		_id: product._id,
	};
}
